module.exports = __webpack_public_path__ + "static/img/peo1.1cd7620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/peo1.jpg
// module id = CmWa
// module chunks = 3